import { BiChevronRight, BiPencil, BiPlus, BiSolidDislike, BiSolidLike } from "react-icons/bi";
import { Button } from "../../../pages/helpCenter";
import { BsLayers, BsTrash2 } from "react-icons/bs";

export const CategoryDetail = ({ category, subcategories, articles, onEdit, onDelete, onAddSubcategory, onAddArticle, onOpenSubcategory, onOpenArticle }) => {
  return (
    <div className="mx-auto max-w-3xl px-6 py-8 sm:px-10">
      <div className="mb-6 flex items-start justify-between gap-4">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full"/>
            <span className="text-xs font-semibold uppercase tracking-wide text-slate-400">Category</span>
          </div>
          <h1 className="font-serif text-2xl font-bold text-slate-900">{category.name}</h1>
          {category.description && <p className="mt-2 text-sm text-slate-500">{category.description}</p>}
        </div>
        <div className="flex shrink-0 gap-2">
          <Button variant="secondary" size="sm" onClick={onEdit}>
            <BiPencil size={14} /> Edit
          </Button>
          <Button variant="dangerGhost" size="sm" onClick={onDelete}>
            <BsTrash2 size={14} /> Delete
          </Button>
        </div>
      </div>

      <div className="mb-8 grid grid-cols-2 gap-3 sm:grid-cols-2 sm:w-64">
        <div className="rounded-lg border border-slate-200 bg-white px-3 py-2">
          <p className="text-xs text-slate-400">Subcategories</p>
          <p className="text-lg font-semibold">
            {subcategories.length}
          </p>
        </div>
        <div className="rounded-lg border border-slate-200 bg-white px-3 py-2">
          <p className="text-xs text-slate-400">Articles</p>
          <p className="text-lg font-semibold">
            {articles.length}
          </p>
        </div>
      </div>

      <div className="mb-8">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-sm font-semibold text-slate-900">Subcategories</h3>
          <Button variant="ghost" size="sm" onClick={onAddSubcategory}>
            <BiPlus size={14} /> Add subcategory
          </Button>
        </div>
        {subcategories.length === 0 ? (
          <p className="rounded-lg border border-dashed border-slate-300 px-4 py-6 text-center text-sm text-slate-400">
            No subcategories yet.
          </p>
        ) : (
          <div className="grid gap-3 sm:grid-cols-2">
            {subcategories.map((s) => (
              <button
                key={s.id}
                type="button"
                onClick={() => onOpenSubcategory(s)}
                className="rounded-xl border border-slate-200 bg-white p-4 text-left transition-shadow hover:shadow-md"
              >
                <div className="flex items-center gap-2 text-slate-800">
                  <BsLayers size={15} className="text-slate-400" />
                  <span className="font-medium">{s.name}</span>
                </div>
                {s.description && <p className="mt-1.5 line-clamp-2 text-xs text-slate-500">{s.description}</p>}
              </button>
            ))}
          </div>
        )}
      </div>

      <div>
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-sm font-semibold text-slate-900">Articles in this category</h3>
          <Button variant="ghost" size="sm" onClick={onAddArticle}>
            <BiPlus size={14} /> Add article
          </Button>
        </div>
        {articles.length === 0 ? (
          <p className="rounded-lg border border-dashed border-slate-300 px-4 py-6 text-center text-sm text-slate-400">
            No articles yet.
          </p>
        ) : (
          <div className="space-y-2">
            {articles.map((a) => (
              <button
                key={a.id}
                type="button"
                onClick={() => onOpenArticle(a)}
                className="flex w-full items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white p-4 text-left transition-shadow hover:shadow-md"
              >
                <div className="min-w-0">
                  <p className="truncate font-medium text-slate-800">{a.title}</p>
                  {a.description && <p className="mt-0.5 truncate text-xs text-slate-500">{a.description}</p>}
                </div>
                <div className="flex shrink-0 items-center gap-3">
                  <span className="flex items-center gap-1 text-xs text-emerald-600">
                    <BiSolidLike size={13} />
                    {a?.helpfulCount ?? 0}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-rose-500">
                    <BiSolidDislike size={13} />
                    {a?.notHelpfulCount ?? 0}
                  </span>
                  <BiChevronRight size={16} className="shrink-0 text-slate-300" />
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}